/* eslint-disable */
// Map from tenant ID to bank name
export const bankNames: Record<number, string> = {
  0: "Banque Cantonale Neuchâteloise",
  // 0: "HSBC",
  // 0: "Bankinter",
  // 1: "PostFinance",
};

// Map from tenant ID to bank key
export const bankKeys: Record<string, string | undefined> = {
  0: process.env.REACT_APP_DEMO_KEY,
  1: process.env.REACT_APP_PF_KEY
};

export const fileExtensionRegex: RegExp = /\.([0-9a-z]+)(?:[\?#]|$)/i;

export const axaDiProductUniqueCode = "4d8758b8-6970-4f95-ad23-757794042eb0";
export const axaPpiProductUniqueCode = "03a53d0d-2331-4f86-8b18-357a930eddbc";

export const languages: string[] = ["en", "de", "fr", "it"];